import * as styleConstants from "@affinity/constants/StyleConstants";
import * as styleHelpers from "@affinity/constants/StyleHelpers";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import * as React from "react";
import styled from "styled-components";

interface Props extends WidgetProps { }

const StyledGridContainer = styled(GridContainer)`
    padding: ${styleHelpers.rem(15)};
`;

const GridItem1 = styled(GridItem)`
    padding: 0 ${styleHelpers.rem(15)} ${styleHelpers.rem(40)} 0;
    @media (min-width: ${styleHelpers.rem(768)}){
        padding: 0 ${styleHelpers.rem(20)} 0 0;
	}
    @media (min-width: ${styleHelpers.rem(1024)}){
        padding: 0 ${styleHelpers.rem(70)} 0 0;
	}
    @media (min-width: ${styleHelpers.rem(1280)}){
        padding: 0 ${styleHelpers.rem(80)} 0 0;
	}
`;

const GridItem2 = styled(GridItem)`
    padding: 0 0 0 ${styleHelpers.rem(15)};
    @media (min-width: ${styleHelpers.rem(768)}){
        padding: 0 0 0 ${styleHelpers.rem(20)};
	}
    @media (min-width: ${styleHelpers.rem(1024)}){
        padding: 0 0 0 ${styleHelpers.rem(70)};
    }
    @media (min-width: ${styleHelpers.rem(1280)}){
        padding: 0 0 0 ${styleHelpers.rem(80)};
	}
`;

const GeneralContent: React.FC<Props> = (props: Props) => {
    const { id } = props;

    return <StyledGridContainer>
        <GridItem1 width={[12,12,8,7,8]}>
            <Zone contentId={id} zoneName="Content 1" />
        </GridItem1>
        <GridItem2 width={[12,12,4,5,4]}>
            <Zone contentId={id} zoneName="Content 2" />
        </GridItem2>
    </StyledGridContainer>;
};

const widgetModule: WidgetModule = {
    component: GeneralContent,
    definition: {
        group: "Basic",
        icon: "distribute-spacing-vertical",
    },
};

export default widgetModule;
